// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"smart-generator_productcontent__gJoTO"};